export default "__VITE_ASSET__BBtafsbh__"